import {fetchRemote} from "./api-util";

import security from "../Util/security";
import growler from '../Util/growler';

const apiEndpoint = '/api/TemplateEditor/';
const controllerEndpoint = '/';

const cache = {};

function fetchResultValue(endpoint, opts) { 
    return new Promise((resolve, reject) => {
        fetchRemote(endpoint, opts).then((response) => {
            response.json().then((data) => {
                
                if(!data.Success) {
                    const errors = data.errors || data.Errors;
                    growler.bootstrapDanger(errors.join('<br />'));
                    reject();
                }

                const value = data.value || data.Value; 
                resolve(value);

            }, reject);
        }, reject);
    });
}

function fetchResult(endpoint, opts) { 
    return new Promise((resolve, reject) => {
        fetchRemote(endpoint, opts).then((response) => {
            response.json().then((data) => {
                resolve(data);
            }, reject);
        }, reject);
    });
}

module.exports = {
    saveTemplate (model) {
        return fetchResult(apiEndpoint + 'Edit/', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(model)
        });
    },
    getTemplate (id, getParent) {
        const query = getParent === true ? 
            'Get/' + id + '?getParent=true' :
            'Get/' + id;

        return fetchResultValue(apiEndpoint + query);
    },
    getRowTypes () {
        const cacheKey = 'GET_ROWTYPES';
        
        //RowTypes are static; they don't have to be retrieved multiple times/page load
        return (cache[cacheKey] = cache[cacheKey] || fetchResultValue(apiEndpoint + 'GetRowTypes/'));
    },
    getColumnTypes () {
        const cacheKey = 'GET_COLUMNTYPES';
        
        //ColumnTypes are static; they don't have to be retrieved multiple times/page load
        return (cache[cacheKey] = cache[cacheKey] || fetchResultValue(apiEndpoint + 'GetColumnTypes/'));
    },
    getParentTemplateList(templateId){
        const endpoint = `${apiEndpoint}Parents/${templateId}/List`;

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint).then(response => {
                response.json().then(data => {
                    if(!data.Success){
                        reject(data.Errors);
                        return;
                    }

                    resolve(data.Value);
                }, reject);
            }, reject);
        });
    },
    getTemplateList(state){
        let endpoint = `${apiEndpoint}List/`;
        
        if(state !== undefined){
            endpoint = `${endpoint}${state}`;
        }

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint).then(response => {
                response.json().then(data => {
                    if(!data.Success){
                        reject(data.Errors);
                        return;
                    }

                    resolve(data.Value);
                }, reject);
            }, reject);
        });
    },
    getSharedTemplates(id) {
        const endpoint = `${controllerEndpoint}Template/${id}/Share`;

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint).then(response => {
                response.json().then(result => {
                    if(!result.success){
                        reject(result.errors);
                        return;
                    }

                    resolve(result.value);
                }, reject);
            }, reject);
        });
    },
    publishTemplate(id){
        const endpoint = `${controllerEndpoint}Template/${id}/Publish`;
        
        const opts = {
            method: 'POST'
        };

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint, opts).then(response => {
                response.json().then(result => {
                    if(!result.success){
                        reject(result.errors);
                        return;
                    }

                    resolve();
                }, reject);
            }, reject);
        });
    },
    shareTemplate(id, divisionId){
        const endpoint = `${controllerEndpoint}Template/${id}/Share`;

        const opts = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ divisionId })
        };

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint, opts).then(response => {
                response.json().then(result => {
                    if(!result.success){
                        reject(result.errors);
                        return;
                    }

                    resolve(result.value);
                }, reject);
            }, reject);
        });
    },
    deleteTemplate(id) {
        const endpoint = `${apiEndpoint}Delete/${id}`;

        const opts = {
            method: 'DELETE'
        };

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint, opts).then(response => {
                response.json().then(result => {
                    if(!result.Success){
                        reject(result.Errors);
                        return;
                    }

                    resolve();
                }, reject);
            }, reject);
        });
    },
    getTemplatePreviewUrl(id){
        return `${controllerEndpoint}Template/${id}/Preview/Embed/`;
    },
    getTemplatePreview(id) {
        const endpoint = this.getTemplatePreviewUrl(id);

        return new Promise((resolve, reject) => {
            fetchRemote(endpoint).then(response => {
                response.json().then(result => {
                    if(!result.Success){
                        reject(result.Errors);
                        return;
                    }

                    resolve(result.Value);
                }, reject);
            }, reject);
        });
    },
    validateBuilderPermission(grantType){
        return new Promise(resolve =>
            security.validatePermission(security.Permissions.EmvPrimaryTemplateBuilder, grantType).then(
                () => {
                    resolve(true); 
                },
                () => {
                    resolve(false); 
                }
            )
        );
    },
    validateFillerPermission(grantType){
        return new Promise(resolve => 
            security.validatePermission(security.Permissions.EmvTemplateFiller, grantType).then(
                () => {
                    resolve(true); 
                },
                () => {
                    resolve(false); 
                }
            )
        );
    },
    validatePermission(grantType) {
        return new Promise(resolve => {
            let completions = 0;
            let isResolved = false;
            
            const onComplete = (success) => {
                //Once resolved; no need to invoke our callback anymore
                if(isResolved){
                    return;
                }
                
                //Register the completion of one of our promises
                completions++;
                
                //There are two promises, only one needs to be marked as successful
                //If both fail, resolve with false
                //If either one succeeds, resolve with true
                if(success || (!success && completions > 1)) {
                    isResolved = true;
                    resolve(success);
                }
            };

            this.validateBuilderPermission(grantType).then((success) => onComplete(success));
            this.validateFillerPermission(grantType).then((success) => onComplete(success));
        });
    }
};
